import React, { useState, useEffect } from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import slugify from 'slugify';
import { variantsPropType } from '../../util';
import AlternativeItem from './AlternativeItem';
import { elo as theme } from '../../themes';
import { jsx as ___EmotionJSX } from "@emotion/core";
var baseStyles = /*#__PURE__*/css("display:flex;padding:", theme.spacings.xxxSmall, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Alternatives = function Alternatives(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    size = _ref.size,
    variant = _ref.variant,
    name = _ref.name,
    value = _ref.value;
  var _useState = useState(value),
    activeItem = _useState[0],
    setActiveItem = _useState[1];
  var handleSelectItem = function handleSelectItem(index) {
    setActiveItem(index);
    onClick(index);
  };
  useEffect(function () {
    setActiveItem(value);
  }, [value]);
  return ___EmotionJSX("div", {
    css: baseStyles,
    "data-test-id": "alternatives-container-" + slugify(name)
  }, children.map(function (_ref2, index) {
    var _ref2$props = _ref2.props,
      icon = _ref2$props.icon,
      disabled = _ref2$props.disabled,
      itemVariant = _ref2$props.variant;
    return ___EmotionJSX(AlternativeItem, {
      selected: activeItem === index,
      disabled: disabled,
      key: icon,
      icon: icon,
      onClick: function onClick() {
        return handleSelectItem(index);
      },
      size: size,
      variant: itemVariant || variant
    });
  }));
};
Alternatives.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: variantsPropType,
  dataTestId: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.number
};
Alternatives.defaultProps = {
  size: 'small'
};
export { Alternatives, AlternativeItem };